/**
 * Near-miss / PB copy for Endless loss (and win) recap score callouts.
 */
export function getRecapScoreCallout(score = 0, bestScore = 0) {
    const runScore = Math.max(0, Math.floor(Number(score) || 0));
    const best = Math.max(0, Math.floor(Number(bestScore) || 0));

    if (runScore <= 0 && best <= 0) {
        return null;
    }

    if (runScore > 0 && runScore >= best) {
        return {
            kind: "personal-best",
            text: "Personal best this run!",
            gap: 0,
        };
    }

    const gap = Math.max(0, best - runScore);
    const nearMissThreshold = Math.max(12, Math.ceil(best * 0.15));

    if (gap > 0 && gap <= nearMissThreshold) {
        return {
            kind: "near-miss",
            text: `Only ${gap} from your best — one more try!`,
            gap,
        };
    }

    return {
        kind: "chase",
        text: `Best to beat: ${best}`,
        gap,
    };
}
